import { DATE_TIME_CONFIG } from "../config";
import { getWeekStart, getDateString } from "../utils/datetime";

// Icons
import {
  Camera,
  Clock,
  Flag,
  ColorSwatch,
  Pencil,
  Clipboard,
  Hourglass,
  CurrencyDollar,
  Calendar,
  Server,
  ChartPie,
  Terminal,
  QuestionMarkCircle,
} from "../components/icons/svg/outline/index";
import { Ruler } from "../components/icons/svg/tools/index";

/**
 * Navigation Links Configuration
 * Centralized configuration for all application navigation links
 * organized by user role/permission level
 */
export const getAppLinksConfig = (baseURL, today) => ({
  debug: [
    {
      label: "Worker Timesheet",
      icon: Terminal,
      href: `/app/timekeeping/worker-timesheet`,
      domain: "timekeeping",
      name: "worker-timesheet",
    },
    {
      label: "Super Timesheet",
      icon: Terminal,
      href: `/app/timekeeping/super-timesheet`,
      name: "timekeeping/super-timesheet",
    },
    {
      label: "Ticket System Demo",
      icon: Flag,
      href: `/app/dev/ticket-demo`,
      domain: "development",
      name: "ticket-demo",
    },
  ],

  crew: [
    {
      label: "Clock In",
      icon: Clock,
      href: "/app/timekeeping/clock-in",
      domain: "timekeeping",
      name: "clock-in",
    },
    {
      label: "Shift Schedule",
      icon: Clipboard,
      href: "/app/timekeeping/worker-schedule",
      domain: "timekeeping",
      name: "worker-schedule",
    },
    {
      label: "Daily Dispatch",
      icon: Calendar,
      href: `/app/planning/dispatch/${getDateString(
        getWeekStart(undefined, DATE_TIME_CONFIG.START_OF_WEEK["dispatch"])
      )}`,
      domain: "planning",
      name: "dispatch",
    },
    {
      label: "R&S Shared Drive",
      icon: Server,
      href: "/app/files/drive",
      domain: "files",
      name: "drive",
    },
  ],

  field: [
    {
      label: "Clock In",
      icon: Clock,
      href: "/app/timekeeping/clock-in",
      domain: "timekeeping",
      name: "clock-in",
    },
    {
      label: "Shift Schedule",
      icon: Clipboard,
      href: "/app/timekeeping/worker-schedule",
      domain: "timekeeping",
      name: "worker-schedule",
    },
    {
      label: "T&M",
      icon: Flag,
      href: "/app/operations/tm-log",
      domain: "operations",
      name: "tm-log",
    },
    {
      label: "RFI",
      icon: QuestionMarkCircle,
      href: "/app/operations/rfi-log",
      domain: "operations",
      name: "rfi-log",
    },
    {
      label: "Quantities",
      icon: Ruler,
      href: `${baseURL}quantities/report`,
      domain: "django",
      name: "quantities",
    },
    {
      label: "Media Upload",
      icon: Camera,
      href: "/app/files/upload",
      domain: "files",
      name: "upload",
    },
    {
      label: "Mix Designs",
      icon: ColorSwatch,
      href: `${baseURL}fieldapps/mixdesigns/`,
      domain: "django",
      name: "mixdesigns",
    },
    {
      label: "JHA Form",
      icon: Pencil,
      href: `${baseURL}fielddocuments/JHA/`,
      domain: "django",
      name: "JHA",
    },
  ],

  manager: [
    {
      label: "Labor Hours Log",
      icon: Clipboard,
      href: `app/timekeeping/hours-log/${today}`,
      domain: "timekeeping",
      name: "hours-log",
    },
    {
      label: "Unsigned Weekly Timesheets",
      icon: Hourglass,
      href: `/app/timekeeping/timesheets`,
      hasNotification: true,
      domain: "timekeeping",
      name: "unsigned-timesheets",
    },
  ],

  staff: [
    {
      label: "Payroll",
      icon: CurrencyDollar,
      href: `${baseURL}documents/payroll/qb-weekly`,
      domain: "django",
      name: "payroll",
    },
    {
      label: "Planning Schedule",
      icon: Calendar,
      href: "/app/planning/schedule",
      domain: "planning",
      name: "schedule",
    },
    {
      label: "Daily Dispatch",
      icon: Calendar,
      href: `/app/planning/dispatch/${getDateString(
        getWeekStart(undefined, DATE_TIME_CONFIG.START_OF_WEEK["dispatch"])
      )}`,
      domain: "planning",
      name: "dispatch",
    },
    {
      label: "R&S Shared Drive",
      icon: Server,
      href: "/app/files/drive",
      domain: "files",
      name: "drive",
    },
  ],

  executive: [
    {
      label: "Daily Cost Analysis",
      icon: ChartPie,
      href: "/app/analytics/cost",
      domain: "analytics",
      name: "cost",
    },
    {
      label: "Safety Meeting Audit",
      icon: Clipboard,
      href: "/app/operations/safetymeeting",
      domain: "operations",
      name: "safetymeeting",
    },
  ],
});
